{
  "(optional)": "(valfritt)",
  "(required)": "(krävs)"
}
